import { z } from 'zod';

/** One admin-authored highlight+comment on a chat message. */
export const AnnotationSchema = z.object({
  id: z.string(),
  conversationId: z.string(),
  messageId: z.string(),
  annotatorEmail: z.string(),
  quote: z.string(),
  prefix: z.string(),
  suffix: z.string(),
  comment: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Annotation = z.infer<typeof AnnotationSchema>;

export const AnnotationListSchema = z.object({
  annotations: z.array(AnnotationSchema),
});

/** One annotated conversation with aggregates, for the admin list page. */
export const AnnotatedConversationSchema = z.object({
  conversationId: z.string(),
  title: z.string().nullable(),
  userEmail: z.string().nullable(),
  annotationCount: z.number(),
  latestQuote: z.string(),
  latestComment: z.string(),
  latestCreatedAt: z.string(),
});
export type AnnotatedConversation = z.infer<typeof AnnotatedConversationSchema>;

export const AnnotatedConversationListSchema = z.object({
  conversations: z.array(AnnotatedConversationSchema),
  pagination: z.object({
    total: z.number(),
    limit: z.number(),
    offset: z.number(),
    hasMore: z.boolean(),
  }),
});

export const AnnotationMutationSchema = z.object({ ok: z.literal(true) });
